import { render, staticRenderFns } from "./ProofOfDeliveryCityDashboard.vue?vue&type=template&id=ebd1229e&"
import script from "./ProofOfDeliveryCityDashboard.vue?vue&type=script&lang=js&"
export * from "./ProofOfDeliveryCityDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProofOfDeliveryCityDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports